import { NSARouterMakerResult } from "namirasoft-account-react";
import { createRef } from "react";
import { SupportEntities } from "../SupportEntities";
import { SupportLayout } from "../SupportLayout";
import { SupportProps } from "../SupportProps";
import TicketMessages from "../components/TicketMessages";

export interface TicketListPageProps extends NSARouterMakerResult, SupportProps { }

function TicketListPage(props: TicketListPageProps)
{
    const SupportLayout_Ref = createRef<SupportLayout>();
    return (
        <SupportLayout
            {...props}
            ref={SupportLayout_Ref}
            action={{
                description: "This section displays all tickets you have previously submitted. You can open each ticket to review its details, check its current status, and follow the communication history with the support team."
            }}
            pages={{
                entity: SupportEntities.ticket(props, () =>
                {
                    SupportLayout_Ref.current
                        ?.NSALayout_Ref.current
                        ?.NSASectionList_Ref.current
                        ?.NSATable_Main.current
                        ?.NSTable_Main.current
                        ?.reload(null, null);
                }),
                list: {
                    ui: {
                        getChildrenAfter: (_, row) => row && <TicketMessages row={row} />
                    }
                }
            }}
        >
            <></>
        </SupportLayout >
    );
}

export default TicketListPage;